module.exports = __webpack_public_path__ + "img/v2-73e94c7e668662d225a700c42a7362b2_r.73e94c7e.jpg";